/** Frontmatter for the "week5-start-sit-darkness-report" article; the Body lives in week5-start-sit-darkness-report.jsx. */
const meta = {
  slug: 'week5-start-sit-darkness-report',
  title: 'Week 5 Start/Sit: The Darkness Report',
  category: 'Streaming',
  author: 'Andy Darkness',
  excerpt:
    'All 15 games from Thursday night through Monday night, one card each: start, flex and sit calls, game-time decision callouts, a slate board of lines and implied points, an injury board with inactive windows, a handcuff board, D/ST and IDP streamers, position tiers, the Darkness Rulings and the inactives checklist.',
  readMinutes: 45,
  date: '2026-10-08',
};

export default meta;
